import { DATA_ROOM_STATIC_ID } from "@/components/data-room/DataRoomCategoriesDefines";
import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { DataRoomRedFlag, RedFlagStatus } from "@/models/data-room/DataRoomRedFlag";

export class RedFlagService {
  private path: string;

  constructor(path: string) {
    this.path = path;
  }

  createRedFlag(dto: DataRoomRedFlag): Promise<ApiResponseV2<DataRoomRedFlag>> {
    return HttpClientV2.post(`${this.path}/create`, dto);
  }

  getAll(staticId: DATA_ROOM_STATIC_ID): Promise<ApiResponseV2<DataRoomRedFlag[]>> {
    return HttpClientV2.get(`${this.path}?staticId=${staticId}`);
  }

  update(externalId: string, name: string, status: RedFlagStatus): Promise<ApiResponseV2<DataRoomRedFlag>> {
    return HttpClientV2.put(`${this.path}`, {
      externalId,
      name,
      status,
    });
  }

  delete(externalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.delete(`${this.path}?externalId=${externalId}`);
  }
}

export default new RedFlagService("/api/red-flag");
